import {getTodayStartTime} from 'shared/utils/dateTime';
import {redistributeBudget, freezeState} from 'core/LifeCycle';
import {isFinished} from 'core/Budget';
import {insert} from 'core/MoneyBox';

export function startNewDay(state: CoreState): LifeCycleState {
  const todayStart = getTodayStartTime();
  const newState = isFinished(state.budget) ? freezeState(state) : redistributeBudget(state);

  return {
    ...newState,
    moneyBox: insert(state.moneyBox, 0),
    lastRecalcDateTime: todayStart,
  };
}
